import { useState } from "react";
import { handleValidation } from "../../../utils/validationInput";

//import "./InputCss.css";
import {
    FieldError,
    FieldErrors,
    Path,
    UseFormRegister,
} from "react-hook-form";


const INPUT_COLOR = "#D0D0D0";
const INPUT_COLOR_ERROR = "red";




export type TInputCuilProps = {
    label: Path<any>;
    fieldName: string;
    register: UseFormRegister<any>;
    required?: boolean;
    error?: FieldError | FieldErrors;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    readOnly?: boolean;
    value?: string;
};


export default function InputCuil({
    label,
    fieldName,
    register,
    required,
    error,
    onChange,
    onBlur,
    style,
    readOnly,
    value,
}: TInputCuilProps) {
    const [isValid, setIsValid] = useState(true);

    return (
        <div className="box">
            <input
                readOnly={readOnly}
                className="input"
                placeholder=" "
                type="text"
                {...register(fieldName, {
                    required,
                    validate: (value: any) => {
                        const isValidLength = /^\d{11}$/.test(value);
                        setIsValid(isValidLength);
                        return handleValidation("text", value);
                    },
                    onChange: (e) => {
                        onChange && onChange(e);
                    },
                    onBlur: (e) => {
                        onBlur && onBlur(e);
                    },
                })}
                name={fieldName}
                value={value}
                style={{
                    cursor: "pointer",
                    borderColor: `${error || !isValid ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
                    ...style,
                }}
            />
            {label && <span className="label">{label}</span>}

            {error?.message && (
                <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
            )}
            {error?.type === "required" && (
                <span style={{ color: INPUT_COLOR_ERROR }}>{label} es requerido*</span>
            )}

            {!isValid && (
                <span style={{ color: INPUT_COLOR_ERROR }}>El campo debe tener 11 dígitos.</span>
            )}
        </div>
    );
}
